import { COMPANIES } from 'Enums/Companies';
import {
  SingerData,
  IweckData,
  FranklinData,
  BoelterData
} from '@setvi/shared/enums';

export const isValidEmail = (email: string) => {
  if (!email) return false;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const getCompanyData = (companyId: number) => {
  switch (companyId) {
    case COMPANIES.IWECK_DEV:
      return { name: IweckData.Name, address: IweckData.Address };
    case COMPANIES.FRANLINK_DEV:
    case COMPANIES.FRANLINK_PROD:
      return { name: FranklinData.Name, address: FranklinData.Address };
    case COMPANIES.BOELTER_DEV:
    case COMPANIES.BOELTER_PROD:
      return { name: BoelterData.Name, address: BoelterData.Address };
    case COMPANIES.SINGER_DEV:
    case COMPANIES.SINGER_PROD:
      return { name: SingerData.Name, address: SingerData.Address };
    default:
      return { name: '-', address: '-' };
  }
};
